var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "사업분야",
      "sc": "에프원시큐리티는 전문가들로 이루어져 있습니다.",
      "tabActive": "컨설팅 사업",
      "icon": "/images/sub/visual/sv2-icon.svg",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section",
    attrs: {
      "id": "consulting"
    }
  }, [_c('v-container', [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5",
      "xl": "4",
      "data-aos": "fade-right"
    }
  }, [_c('h4', {
    staticClass: "consulting-tit sub-tit--md font-weight-bold"
  }, [_vm._v(" 정보보호 컨설팅 서비스 ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7",
      "xl": "8",
      "data-aos": "fade-left"
    }
  }, [_c('p', {
    staticClass: "sub-tit--sm color-gray line-height-16"
  }, [_vm._v(" F1Security 정보보호 컨설팅 서비스는 고객의 정보자산을 각종 위협으로부터 안전하게 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 보호하기 위하여 Risk 관리를 기반으로 다양한 분야의 정보보안 컨설팅 서비스를 제공합니다. "), _c('br'), _vm._v(" 기본적인 정보보호 컨설팅을 기준으로 취약점 진단 컨설팅, 정보보호 인증지원 컨설팅, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 주요 정보통신기반시설 컨설팅, 개인정보보호 컨설팅 등 전문적이고 품질 높은 종합 정보보호 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 컨설팅 서비스를 지속적으로 제공하고 있습니다. ")])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm bg-grey"
  }, [_c('v-container', [_c('v-img', {
    staticClass: "d-none d-lg-block mx-auto",
    attrs: {
      "max-width": "968",
      "src": "/images/sub/business/consulting/consulting-img1.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-lg-none mx-auto",
    attrs: {
      "max-width": "670",
      "src": "/images/sub/business/consulting/consulting-img1-mo.png"
    }
  })], 1)], 1), _c('section', {
    staticClass: "sub-section pt-40 pt-md-80 pt-lg-100"
  }, [_c('v-container', [_c('div', {
    staticClass: "consulting-table page-text mb-80 mb-md-100 mb-lg-140"
  }, [_c('div', {
    staticClass: "thead d-none d-lg-block"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_c('p', [_vm._v("분류")])]), _c('div', {
    staticClass: "th"
  }, [_c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v("컨설팅")]), _c('p', [_vm._v("내용")])])])])]), _c('div', {
    staticClass: "tbody"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" 정보보호 인증 컨설팅 ")]), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" ISMS, ISMS-P, ISO27001 ")]), _c('p', [_vm._v(" 정보통신망의 안전성 확보를 위하여 수립·운영하고 있는 기술적·물리적 보호조치 등 종합적인 정보보호(개인정보보호)관리체계에 대한 인증 획득 ")])])])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" 정보보호 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 개인정보보호 컨설팅 ")]), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 정보보호 체계구축 ")]), _c('p', [_vm._v(" 기업의 정보시스템 안전성/신뢰성 증대 및 비즈니스 경쟁력 향상을 위한 국내/국제 보안표준에 의거한 종합적인 정보보호 관리체계 구축 ")])]), _c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 개인정보보호 체계구축 ")]), _c('p', [_vm._v(" 개인정보의 라이프사이클에 걸쳐 개인정보를 취급하는 시스템과 취급프로세스에 존재하는 위협과 취약점을 식별하고 위험을 평가하여 기업에 적합한 보호대책 수립 ")])]), _c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 정보보호 마스터플랜 ")]), _c('p', [_vm._v(" 기업의 주요 정보자산에 대한 관리/물리/기술적 취약점 및 위험분석을 통해 체계적 보안 마스터플랜 수립 ")])]), _c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 보안감사 ")]), _c('p', [_vm._v(" 기업의 보안체계가 효율적으로 운영되고 있는지를 문서체계 및 증빙자료, 실사 등을 통해 점검 ")])]), _c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 모의해킹 ")]), _c('p', [_vm._v(" 해커의 관점으로 IT 서비스의 주요 취약점을 도출하고 해결방안 제시 ")])]), _c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 기술취약점 진단 ")]), _c('p', [_vm._v(" 기업의 중요 인프라시스템(서버/DB/어플리케이션/네트워크/보안시스템 등)에 존재하는 취약점을 도출하여 해결방안 제시 ")])])])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v(" 정보보호 솔루션 ")]), _c('div', {
    staticClass: "td"
  }, [_c('div', {
    staticClass: "table-detail"
  }, [_c('p', [_vm._v(" 정보보호 솔루션 ")]), _c('p', [_vm._v(" 고객사 환경분석 후 각 영역별/기능성/성능면에서 최적의 보안솔루션 제공 ")])])])])])]), _c('div', {
    staticClass: "mb-26 mb-lg-42"
  }, [_c('h4', {
    staticClass: "sub-tit--md mb-8 mb-lg-20",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 컨설팅 방법론 전략 ")]), _c('p', {
    staticClass: "sub-tit--sm color-gray"
  }, [_vm._v(" 고객사의 업무특성 및 현황을 정확히 이해하고, 최적화된 정보보호관리체계를 구축·운영하는 것으로써, 체계적인 컨설팅을 수행합니다. ")])]), _c('div', {
    staticClass: "radius-md bg-gra pa-30 px-md-16 py-md-70 color-white text-center"
  }, [_c('div', {
    staticClass: "row-cols-2 row-cols-md-3 row-cols-lg-5 d-flex flex-wrap justify-center consulting-item-group ma-n16 ma-md-n30 ma-lg-0"
  }, [_c('div', {
    staticClass: "pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/business/consulting/consulting-icon1.png",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 정보보호 컨설팅에 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 적합한 전문 컨설턴트 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 선별 투입 ")])])]), _c('div', {
    staticClass: "pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/business/consulting/consulting-icon2.png",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 보안관련 Compliance 등 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 기업환경에 대한 명확한 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 이해 확보 ")])])]), _c('div', {
    staticClass: "pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/business/consulting/consulting-icon3.png",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 최신 보안기술을 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 활용 취약점 진단 및 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 대책수립 ")])])]), _c('div', {
    staticClass: "pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1000"
    }
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/business/consulting/consulting-icon4.png",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 자율적인 정보보호 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 관리체계 정착을 위한 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 실행력 극대화 ")])])]), _c('div', {
    staticClass: "pa-16 pa-md-30 px-lg-16 py-lg-0 consulting-item"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1300"
    }
  }, [_c('img', {
    staticClass: "d-block mb-12 mb-lg-24",
    attrs: {
      "src": "/images/sub/business/consulting/consulting-icon5.png",
      "alt": ""
    }
  }), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" 지식 내재화를 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 위한 실질적인 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 지식전수 ")])])])])])])], 1), _c('v-container', [_c('v-divider')], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-40 mb-md-80 mb-lg-100"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h4', {
    staticClass: "sub-tit--md mb-8 mb-lg-20",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 컨설팅 방법론 ")]), _c('p', {
    staticClass: "sub-tit--sm color-gray mb-8 mb-lg-20"
  }, [_vm._v(" F1Security 방법론은 ISMS, ISMS-P, ISO27001 등 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 인증을 비롯한 국내외 보안모델을 참고하여 만든 방법론으로써 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 각 모듈이 유기적으로 연결되어 있으며 고객사의 정보보호 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 관리체계 수립에 적용되어 성공적인 컨설팅을 수행하도록 합니다. ")]), _c('p', {
    staticClass: "sub-tit--sm color-gray"
  }, [_vm._v(" 취약점 진단 시 이용하는 체크리스트는 국내외 보안모델 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 제조사의 보안가이드 등을 고려하여 관리/물리 및 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 기술적 영역에 다양한 체크리스트를 보유하고 있어 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 모든 유형의 정보자산에 대해 취약점 진단을 실시할 수 있습니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "440",
      "src": "/images/sub/business/consulting/consulting-img2.png"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "mb-40 mb-md-80 mb-lg-100"
  }, [_c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 정보보호 기준 ")]), _c('v-img', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "max-width": "1200",
      "src": "/images/sub/business/consulting/consulting-img3.png"
    }
  }), _c('v-img', {
    staticClass: "d-block d-lg-none mx-auto",
    attrs: {
      "max-width": "670",
      "src": "/images/sub/business/consulting/consulting-img3-mo.png"
    }
  })], 1), _c('div', {
    staticClass: "mb-40 mb-md-80 mb-lg-100"
  }, [_c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 정보보호관리체계 인증 컨설팅 ")]), _c('div', {
    staticClass: "w-100 radius-md border page-text mb-12 mb-lg-14"
  }, [_c('v-row', {
    staticClass: "pa-16 pa-md-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-md-24 mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "right-line font-weight-bold"
  }, [_vm._v("KISA ISMS/ISMS-P 인증")])]), _c('v-col', {
    staticClass: "pa-md-24",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 개인정보 및 정보 자산조사, 개인정보 흐름분석, 위험평가, 개인정보 및 정보보호대책 수립 ")])])], 1)], 1), _c('div', {
    staticClass: "w-100 radius-md border page-text mb-12 mb-lg-14"
  }, [_c('v-row', {
    staticClass: "pa-16 pa-md-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-md-24 mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "right-line font-weight-bold"
  }, [_vm._v("ISO27001 인증")])]), _c('v-col', {
    staticClass: "pa-md-24",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 자산분석, 위험평가, 적용성 보고서, 내부감사 ")])])], 1)], 1)]), _c('div', [_c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 취약점 분석 컨설팅 ")]), _c('div', {
    staticClass: "w-100 radius-md border page-text mb-12 mb-lg-14"
  }, [_c('v-row', {
    staticClass: "pa-16 pa-md-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-md-24 mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "right-line font-weight-bold"
  }, [_vm._v("서버/네트워크/보안장비/응용진단")])]), _c('v-col', {
    staticClass: "pa-md-24",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" IT 인프라 및 서비스 자산조사, 취약점 분석, 보호대책 수립 ")])])], 1)], 1), _c('div', {
    staticClass: "w-100 radius-md border page-text mb-12 mb-lg-14"
  }, [_c('v-row', {
    staticClass: "pa-16 pa-md-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-md-24 mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "right-line font-weight-bold"
  }, [_vm._v("모의해킹")])]), _c('v-col', {
    staticClass: "pa-md-24",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 시나리오 기반의 모의해킹 수행 ")])])], 1)], 1), _c('div', {
    staticClass: "w-100 radius-md border page-text mb-12 mb-lg-14"
  }, [_c('v-row', {
    staticClass: "pa-16 pa-md-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-md-24 mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('p', {
    staticClass: "right-line font-weight-bold"
  }, [_vm._v("소스분석")])]), _c('v-col', {
    staticClass: "pa-md-24",
    attrs: {
      "cols": "12",
      "md": "9"
    }
  }, [_c('p', {
    staticClass: "color-gray"
  }, [_vm._v(" 어플리케이션 소스 취약점 분석 ")])])], 1)], 1)])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }